"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcFixedAssetTypeBadge = void 0;
const UcFixedAssetTypeBadge_yaml_component_1 = __importDefault(require("./UcFixedAssetTypeBadge.yaml?component"));
exports.UcFixedAssetTypeBadge = UcFixedAssetTypeBadge_yaml_component_1.default;
